<template>
    <div class="timeRange" :class="{ 'disabled': disabled }">
        <div class="calendar">
            <table>
                <thead>
                <tr>
                    <th rowspan="6" class="weekRow"><b>周/时间</b></th>
                </tr>
                <tr>
                    <td v-for="index in 24" colspan="2" :key="index">{{ index -1 }}</td>
                </tr>
                </thead>
                <tbody @mousemove.prevent="handleMouseMove">
                    <tr v-for="(item, index) in defaultData" :key="index">
                        <td>{{ item }}</td>
                        <!-- 修改 v-for 的范围从 24 到 48 -->
                        <td class="calendar-atom-time" v-for="i in 48" :key="index + '-' + (i-1)"
                            :class="{ 'active': selectCells[`${index}_${i-1}`] }" 
                            @mousedown.prevent="handleMouseDown(index, i-1, $event)"
                            @mouseup.prevent="handleMouseUp(index, i-1)">
                        </td>
                    </tr>
                    <!-- 将 div 移到这里 -->
                    <div id="box" v-show="moveStartEvent"></div>
                </tbody>
            </table>
            <p class="dropTimesTips"><span class="star">*</span>可拖动鼠标选择时间段</p>
            <div class="table-core">
                <div class="table-core-header">
                    <span>已选时间段</span>
                    <el-button type="text" class="clearBtn" :disabled="disabled" @click="handleClear">清空</el-button>
                </div>
                <div class="drawer_item_time_srcoll">
                    <div class="drawer_item_time">
                        <div v-for="(item, index) in selectDate" :key="index">
                            <div class="drawer_item_time_title">{{item.label}}</div>
                            <div v-for="(itemc, indesc) in item.data" :key="indesc" class="drawer_item_time_body">{{ itemc[0] }}~{{ itemc[1] }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import _ from 'lodash';
    export default {
        name: 'WkDropTime',
        props: {
            // 传入数据 v-model 绑定值
            value: {
                type: String
            },
            defaultData: { // 默认数据 表列
                type: Array,
                default: () => ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                // 所选格子
                selectCells: {},
                // 所选时间数据（做提交时使用）
                selectDate: {},
                // 记录鼠标位置
                moveStartEvent: false,
                moveStartColumn: 0, // 列
                moveStarRow: 0, // 行
                moveStartX: 0,
                moveStartY: 0
            }
        },
        watch: {
            value: {
                handler(newValue, oldValue) {
                    if (_.isEqual(newValue, oldValue)) {
                        return;
                    };

                    this.setSelectedCellsByStatus(newValue)
                },
                deep: true,
                immediate: true
            }
        },
        methods: {
            // 初始
            init (data) {
                if (data && data instanceof Object) {
                    this.selectCells = data
                } else {
                    this.selectCells = {}
                }
                this.getSelectDate()
            },
            
            // 按下
            handleMouseDown (column, row, e) {
                this.moveStartEvent = true
                this.moveStartColumn = column
                this.moveStarRow = row
                this.moveStartX = e.layerX
                this.moveStartY = e.layerY
            },
            
            // 松开
            handleMouseUp (column, row) {
                if (this.moveStartEvent) {
                    this.moveStartEvent = false

                    const dom = this.$el.querySelector('#box')
                    dom.style.left = 0 + 'px'
                    dom.style.top = 0 + 'px'
                    dom.style.width = 0 + 'px'
                    dom.style.height = 0 + 'px'

                    const X = row - this.moveStarRow
                    const Y = column - this.moveStartColumn
                    const checked = !this.selectCells[`${column}_${row}`]
            
                    if (X > -1 && Y > -1) {
                    const obj = _.cloneDeep(this.selectCells)
                    for (let i = this.moveStartColumn; i <= column; i++) {
                        for (let j = this.moveStarRow; j <= row; j++) {
                        var key = `${i}_${j}`
                        if (checked) {
                            obj[key] = checked
                        } else if (obj[key]) {
                            delete obj[key]
                        }
                        }
                    }
                    this.selectCells = obj
                    this.$forceUpdate()
                    this.getSelectDate()
                    }
                }
                this.moveStartDay = 0
                this.moveStarTime = 0
            },
            
            // 滑动中
            handleMouseMove (e) {
                if (this.moveStartEvent) {
                    const dom = this.$el.querySelector('#box')
                    const X = e.layerX - this.moveStartX
                    const Y = e.layerY - this.moveStartY
                    if (X >= 0 && Y >= 0) {
                        dom.style.left = this.moveStartX + 'px'
                        dom.style.top = this.moveStartY + 'px'
                        dom.style.width = X + 'px'
                        dom.style.height = Y + 'px'
                    }
                }
            },
            // 设置数字
            setNumTable (date, setIndex) {
                return (24 * date) + Number(setIndex)
                
            },
            // 获得传入数字转       1_0 true 形势  list [0,1,2,3,4,5,6]
            getIdToString(list) {
                let obj = {}
                if(Array.isArray(list) && list.length != 0) {
                    list.forEach(item=>{
                        if(Number(item) < 24) {
                            obj[`0_${item}`] = true
                        }else{
                            let divisor = Math.floor(item / 24)
                            let remainders = item % 24
                            obj[`${divisor}_${remainders}`] = true
                        }
                    })
                }
                this.selectCells = obj
                this.getSelectDate()
                return obj
            },
            setSelectedCellsByStatus(statusStr) {
                const totalSlots = 48 * this.defaultData.length; // 总格子数
                if (statusStr.length !== totalSlots) {
                    this.$message({
                        message: '传入的状态字符串长度与总格子数不匹配',
                        type: 'warning'
                    });
                    return;
                }

                this.selectCells = {};
                for (let i = 0; i < this.defaultData.length; i++) {
                    for (let j = 0; j < 48; j++) {
                        const index = i * 48 + j;
                        const key = `${i}_${j}`;
                        if (statusStr[index] === '1') {
                            this.selectCells[key] = true;
                        }
                    }
                }
                this.getSelectDate();
            },
            // 组合时间数据
            getSelectDate () {
                const arrId = []
                const arr = []
                const selectionStatus = []; // 新增数组用于存储选中状态
                this.defaultData.forEach((item, index) => {
                    arr.push({
                        label: item,
                        data: []
                    })
                    const dailyStatus = []; // 存储每天的选中状态
                    // 修改遍历范围从 24 到 48
                    for (let i = 0; i < 48; i++) {
                        let o = this.selectCells[`${index}_${i}`]
                        if (o) {
                            let hour = Math.floor(i / 2)
                            let minute = (i % 2 === 0) ? '00' : '30'
                            let startTime = `${hour.toString().padStart(2, '0')}:${minute}`
                            let nextHour = Math.floor((i + 1) / 2)
                            let nextMinute = ((i + 1) % 2 === 0) ? '00' : '30'
                            let endTime = `${nextHour.toString().padStart(2, '0')}:${nextMinute}`
                            
                            arr[index].data.push([startTime, endTime])
                            arrId.push(this.setNumTable(index, i)) 
                            dailyStatus.push(1); // 选中为 1
                        } else {
                            dailyStatus.push(0); // 未选中为 0
                        }
                    }
                    selectionStatus.push(dailyStatus);
                })
                arr.forEach(item => {
                    for (var i = 0; i < item.data.length; i++) {
                    var o = item.data
                    if (o[i + 1] && o[i][1] === o[i + 1][0]) {
                        o[i + 1][0] = o[i][0]
                        item.data.splice(i, 1)
                        i--
                    }
                    }
                })
                this.selectDate = arr
                // console.log('选中提交', this.selectDate)
                // console.log('选中提交ID', arrId)
                let join_status = selectionStatus.flat().join(''); // 将二维数组转换为一维数组并连接为字符串
                this.$emit('input', join_status)
            },
            
            // 清除选择
            handleClear () {
                this.selectCells = {}
                this.getSelectDate()
                this.$forceUpdate()
            },
            
            // 获取数据
            getData () {
                return this.selectDate
            }
        },
    }
</script>

<style lang="scss" scoped>
.timeRange {
  user-select: none;
  position: relative;
  padding: 10px 0;
 
  .calendar {
    display: inline-block;
  }
  &.disabled{
    .calendar-atom-time{
        pointer-events: none;
        cursor: not-allowed;
    }
    table{
        th,td{
            background-color: #F1F4F9 !important;
            &.active{
                background-color: #b4c1ff!important;
            }
        }
    }
  }
 
  table {
    width: 100%;
    border-radius: 4px;
    border-spacing: 0;
    table-layout: fixed;
    border-collapse: collapse;
 
    thead {
      th,
      td {
        height: 24px;
      }
      .weekRow {
        width: 100px;
        min-width: 100px;
        padding: 10px 0
      }
    }
 
    td,
    th {
      outline: 0;
      border: 1px solid #E3E3E3;
      font-size: 12px;
      text-align: center;
      min-width: 12px;
      line-height: 2.2em;
      min-width: 24px;
    }
 
    tbody {
      position: relative;
      overflow: hidden;
 
      td {
        height: 24px !important;
        border: 1px dashed #E3E3E3;
      }
    }
 
    td.active {
      background: #6580ff;
    }
  }
 
  .table-core {
    line-height: 2.4em;
    border: 1px solid #E3E3E3;
    overflow: hidden;

    .table-core-header {
    //   color: #8A8A8A;
    //   text-align: left;
    //   height: 22px;
    //   line-height: 22px;
    //   margin: 8px 0;
    //   display: flex;
    //   font-size: 12px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #edf3f8;
    }
  }
  .dropTimesTips{
    padding: 10px 0px;
        .star{
            color: #ff0000;
        }
    }
  #box {
    background: rgba(241, 1, 85, 0.4);
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
  }
  .drawer_item_time_srcoll{
        width: 100%;
        overflow-y:auto;
        .drawer_item_time{
            display:flex;
            
            .drawer_item_time_title{
                width: 100px;
                text-align: center;
                padding: 6px 0;
                // border: 1px solid #ccc;
                font-weight: border;
            }
            .drawer_item_time_body{
                width: 100px;
                padding: 6px 0;
                text-align: center;
                // border: 1px solid #ccc;
                border-top: none;
            }
        }
    }
}
</style>
